import { AfterContentChecked, AfterContentInit, ChangeDetectionStrategy, Component, ElementRef, HostBinding, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ContentCacheUtils } from 'src/utils/storage.util';

@Component({
    selector: 'app-cta',
    standalone: true,
    imports: [RouterModule],
    templateUrl: './cta.component.html',
    styleUrl: './cta.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CtaComponent implements OnInit {
    @HostBinding('style.color')
    ctaColor: string;
    @HostBinding('style.background-color')
    ctaBackgroundColor: string;
    @HostBinding('style.font-family')
    ctaFontFamily: string;
    @HostBinding('attr.hidden')
    hide: string;
    ctaText: string;
    ctaLink: string;
    // messages: string[] = [
    //     'Book et GRATIS indretningsmøde',
    //     'Ring 86 12 30 40',
    //     'Vi levere i Danmark',
    // ];
    // flag: boolean = false;
    // pps: number = 20;
    // @HostBinding('style.--time')
    // time: string;

    constructor(private elm: ElementRef<HTMLElement>) {}

    ngOnInit(): void {
        var menu = ContentCacheUtils.menu<{
            ctaColor: string,
            ctaBackgroundColor: string,
            ctaFontFamily: string,
            ctaText: string,
            ctaLink: string,
        }>();
        this.ctaColor = menu.ctaColor;
        this.ctaBackgroundColor = menu.ctaBackgroundColor;
        this.ctaFontFamily = menu.ctaFontFamily;
        this.ctaText = menu.ctaText;
        this.ctaLink = menu.ctaLink;
        this.hide = menu.ctaText == null || menu.ctaText.trim().length == 0 ? '' : null;
    }

    // ngAfterContentChecked(): void {
    //     var elm = this.elm.nativeElement;
    //     var child = elm.firstElementChild;
    //     if (this.messages?.length > 0 && !this.flag)
    //         if (elm.clientWidth * 2 > child.clientWidth && child.clientWidth > 0) {
    //             this.flag = child.clientWidth > 0;
    //             var max = Math.ceil(elm.clientWidth * 2 / child.clientWidth)
    //             this.time = (child.clientWidth / this.pps) + 's';
    //             for (let i = 0; i < max; i++) {
    //                 elm.append(elm.firstChild.cloneNode(true));
    //             }
    //             ctaColor
    //             ctaBackgroundColor
    //         }

    // }
}
